import styled from 'styled-components';

interface ComponentWrapperProps {
  align: React.CSSProperties['justifyContent'];
}

export const ComponentWrapper = styled.div<ComponentWrapperProps>`
  box-sizing: border-box;
  height: 100%;
  width: calc(100% - 282px);
  display: flex;
  justify-content: ${(props) => props.align};
  align-items: ${(props) => props.align};
  padding: 200px;
`;
